module.exports = __webpack_public_path__ + "img/image36.b288bc65.png";